import {Component, OnInit} from '@angular/core';
import {MercadoInternoClassificacaoService} from "./mercado-interno-classificacao.service";
import {MercadoInternoMercadoriasService} from "./mercado-interno-mercadorias.service";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup} from "@angular/forms";

declare let swal, $: any;

@Component({
  selector: 'app-mercado-interno-classificacao',
  templateUrl: './mercado-interno-classificacao.component.html'
})
export class MercadoInternoClassificacaoComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"nome":"", "mercadoria":""};

  classificacoes: any[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listMercadorias = [];

  constructor(
    formBuilder: FormBuilder,
    private mercadoriasClassificacaoService: MercadoInternoClassificacaoService,
    private mercadoriasService: MercadoInternoMercadoriasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if(idAcao === '20' || acaoUrl == 'mercado-interno-mercadorias' || acaoUrl == 'prestacao-mapa' || acaoUrl == 'mercado-interno'){
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }
      }
      if(this.func.userIsMaster()){
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      nome: [],
      mercadoria: []
    });

    this.mercadoriasService.get(null, null, ['id', 'nome_pt'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    this.getPage(1);
  }

  delete(classificacao) {
    let classificacoes = this.classificacoes;
    let mercadoriasClassificacaoService = this.mercadoriasClassificacaoService;
    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarIndiceClassificacao')+classificacao.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        let index = classificacoes.indexOf(classificacao);
        classificacoes.splice(index, 1);

        mercadoriasClassificacaoService.apagar(classificacao.id)
          .subscribe(res => {
              self.classificacoes = classificacoes;
            },
            err => {
              classificacoes.splice(index, 0, classificacao);
              self.classificacoes = classificacoes;
              self.func.showErro(err.json());
            });
      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.nome != ''){
      filtros['nome'] = '**:'+this.filtroPesquisa.nome;
    }

    if(this.filtroPesquisa.mercadoria != ''){
      filtros['id_mercadoria'] = this.filtroPesquisa.mercadoria;
    }

    this.mercadoriasClassificacaoService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria', 'defeito'], filtros)
      .subscribe(
        json => {
          this.classificacoes = json.Payload;
          this.totalItens = json.Records;
          this.carregandoTabela = false;
        },
        error => {
          this.carregandoTabela = false;
          this.func.showErro(error.json());
        });
  }

  resetFiltros(){
    this.filtroPesquisa = {"nome":"", "mercadoria":""};
    this.formPesquisaAvancada.reset();
    this.getPage(1);
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('hide');
    this.getPage(1);
  }

  limpaPesquisaAvancada() {
    this.resetFiltros();
    $('#modalPesquisaAvancada').modal('hide');
  }

}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-classificacao.component.ts